import React from 'react'

export default function ViewReason({comment}) {
    return (
        <div>
            {comment}
        </div>
    )
}
